import { render } from "./ProductHero.vue?vue&type=template&id=212b14a4&scoped=true"
import script from "./ProductHero.vue?vue&type=script&lang=js"
export * from "./ProductHero.vue?vue&type=script&lang=js"

import "./ProductHero.vue?vue&type=style&index=0&id=212b14a4&scoped=true&lang=scss"

import exportComponent from "/Users/skynet/Documents/Sites Safe OK MAIS PEUT ETRE PAS A JOUR/Safe_Sites_Modifs/SAFE_ORTHO/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-212b14a4"]])

export default __exports__